var map = {
	"./en/banner_02.png": "o9Db",
	"./es/banner_02.png": "gG5E",
	"./pt/banner_02.png": "bGAO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "l+Vd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/banner_02\.png$
// module id = l+Vd
// module chunks = 0